import { Flex } from 'portal-commons';
import { faAddressBook } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid } from '@material-ui/core';

import BrandDetailItem from '../BrandDetailItem';
import { BrandDetail } from '../../types';

interface BusinessContactDetailsProps {
  brand: BrandDetail;
}

const BusinessContactDetails: React.FC<BusinessContactDetailsProps> = ({
  brand,
}) => {
  return (
    <>
      <div className="details-heading contact-details">
        <div className="title" style={{ width: '100%' }}>
          <Flex
            sx={{
              flexDirection: 'row',
              alignItems: 'center',
              columnGap: '8px',
            }}
          >
            <FontAwesomeIcon icon={faAddressBook} size="xl" />
            <h3 className="heading1" style={{ flex: 1 }}>
              Business Contact Details
            </h3>
          </Flex>
        </div>
      </div>
      <Grid container data-testid="businessContactDetails">
        <Grid item xs={6}>
          <BrandDetailItem
            xs={5}
            title="Name"
            value={`${brand.businessContactFirstName ?? ''} ${
              brand.businessContactLastName ?? ''
            }`.trim()}
          />
          <BrandDetailItem
            xs={5}
            title="Business Email Address"
            value={brand.businessContactEmail}
          />
        </Grid>
        <Grid item xs={6}>
          <BrandDetailItem
            xs={5}
            title="Title"
            value={brand.businessContactTitle}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default BusinessContactDetails;
